import React, { useState, useRef, useEffect } from 'react';
import ArrowDownGray from '../../assets/images/common/ic_arrow_down_gray.svg';
import ArrowUpBlack from '../../assets/images/common/ic_arrow_up_black.svg';

interface SelectBoxProps {
  label: string;
  required?: boolean;
  value: string;
  onChange: (e: { target: { name: string; value: string } }) => void;
  name: string;
  options: { value: string; label: string }[];
  error?: string;
}

const SelectBox = ({
  label,
  required = false,
  value,
  onChange,
  name,
  options,
  error,
}: SelectBoxProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // 외부 클릭 시 드롭다운 닫기
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const selectedLabel = options.find(opt => opt.value === value)?.label || options[0].label;

  return (
    <div className="mb-[40px] relative" ref={ref}>
      <label className="text-[18px] md:text-[20px] font-semibold text-[#000000] leading-[120%]">
        {label} {required && <span className="text-[#E43E7A]">*</span>}
      </label>
      <div className="relative">
        <button
          type="button"
          className={`w-full border ${error ? 'border-red-500' : 'border-[#D9D9D9]'} rounded-lg px-4 py-4 mt-2 text-[16px] md:text-[20px] font-Regular bg-white focus:ring-0 focus:border-[#E43E7A] appearance-none cursor-pointer placeholder-[#BDBDBD] flex items-center justify-between ${value === '' ? 'text-[#BDBDBD]' : 'text-gray-700'}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>{selectedLabel}</span>
          <span className="pointer-events-none ml-2">
            {isOpen ? (
              <img src={ArrowUpBlack} width={32} height={32} alt="arrow up" />
            ) : (
              <img src={ArrowDownGray} width={32} height={32} alt="arrow down" />
            )}
          </span>
        </button>
        {isOpen && (
          <ul className="absolute left-0 z-10 w-full bg-white border border-[#D9D9D9] rounded-lg shadow-lg mt-2 max-h-72 overflow-auto text-[16px] md:text-[20px] font-Regular">
            {options.map((opt, idx) => (
              <li
                key={opt.value}
                className={`px-4 py-4 cursor-pointer hover:bg-[#F5F5F5] ${value === opt.value && value !== '' ? "text-[#E43E7A] font-bold" : ''} ${idx === 0 ? 'text-[#BDBDBD]' : 'text-gray-700'}`}
                onClick={() => {
                  if (idx !== 0) {
                    onChange({ target: { name, value: opt.value } });
                    setIsOpen(false);
                  }
                }}
                aria-disabled={idx === 0}
              >
                {opt.label}
              </li>
            ))}
          </ul>
        )}
      </div>
      {error && (
        <div className="mt-2">
          <p className="text-[#E43E7A] text-[16px] font-medium">
            {error}
          </p>
        </div>
      )}
    </div>
  );
};

export default SelectBox; 